import { Link } from "react-router-dom";

const Transaction = ({ transactions, handleOpenCModal, setModalData }) => {
  return (
    <div>
      {transactions.map((elem) => {
        let status
        let failedTransactionClass
        if (elem.verify_amount) {
            status ='تراکنش موفق'
        } else {
            status = 'تراکنش ناموفق'
            failedTransactionClass = "red-1"
        }

        let transactionEndAt = new Date(elem.verify_paid_at)
        let options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
        let startJalali = transactionEndAt.toLocaleDateString('fa-IR', options);
        
        let str
        if (transactionEndAt.getTime() > new Date().getTime()) {
            str = 'فعال تا'
        }else {
            str = 'پایان یافته در'
        }

        return (
          elem.transaction_id && (
            <Link
              key={elem.transaction_id}
              onClick={() => {
                handleOpenCModal();
                setModalData(elem.transaction_id);
              }}
            >
              <div className="spc-between paddingUpDown5">
                <p className={`marginTop5 yekan caption-1 ${failedTransactionClass}`}>{status}</p>
                <p className="marginTop5 yekan caption-1 grey-2">
                  {startJalali}
                </p>
                <span className="icon-iconchevron-left purple-1 paddingTop5"></span>
              </div>
            </Link>
          )
        );
      })}
    </div>
  );
};
export default Transaction;
